/**
 * POLISH DETAIL PAGE (thin wrapper)
 *
 * Since Phase 3, this file is a one-line wrapper that delegates to the
 * shared `CommunityItemDetailPage` with `itemType="polish"`. The heavy
 * lifting (query, render, Confirm, Add-to-Collection, Photos from
 * Collectors) lives in that shared component.
 *
 * Kept as its own file so the polish route in `App.tsx` reads cleanly and
 * so any external links / bookmarks that landed on `PolishDetailPage`
 * still resolve. The wrapper adds zero behavior — polish behaves
 * identically to before the Phase 3 refactor.
 *
 * Route: /brands/:brandSlug/polish/:polishSlug
 *   (the `:polishSlug` param is read as `:itemSlug` inside the shared
 *   component — the router doesn't care about the param name here since
 *   both point to the same URL segment.)
 */
import CommunityItemDetailPage from './CommunityItemDetailPage';

export default function PolishDetailPage() {
  return <CommunityItemDetailPage itemType="polish" />;
}
